import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Contractor,
  InspectionInstallation,
  WaterNetworkCharacterization
} from '@authority-labs/api-interfaces';
import { Conclusion } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-certificate-water-network-characterization',
  templateUrl: './certificate-water-network-characterization.component.html',
  styleUrls: ['./certificate-water-network-characterization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateWaterNetworkCharacterizationComponent
  implements OnInit {
  @Input() inspection: WaterNetworkCharacterization;
  @Input() inspectionDate: Date;

  notes: string[] = [];

  get waterNetworkCharacterizationStatus(): string {
    if (
      this.inspection?.isApplicable &&
      this.inspection?.testData?.length > 0
    ) {
      return this.inspection?.testData[0].isPassed
        ? Conclusion.Pass
        : Conclusion.Fail;
    }

    return Conclusion.NotApplicable;
  }

  constructor() {}

  ngOnInit(): void {
    this.notes = this.inspection
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .map((note) => note.notes);
  }

  addMetric(value: number, metric: string = ''): string {
    return value ? `${value}${metric}` : '--';
  }
}
